import Box from '@/Atoms/Box/Box';
import CCText from '@/Atoms/CCText/CCText';
import SlideModal from '@/Atoms/SlideModal';
import CCColors from '@/Utils/CCColors';
import {FontSizes, WINDOW_WIDTH} from '@/Utils/Dimensions';
import {StyleSheet, Pressable, Linking} from 'react-native';
import phoneCall from '../../../Assets/Images/Svgs/phoneCall.svg';
import {Image} from 'react-native';
import callBgPattern from '../../../Assets/Images/Svgs/callBgPattern.svg';
import {SUPPORT_PHONE_NUMBERS} from '../../Renewal/constants/supportConstants';
import {MaterialCommunityIcons} from '@expo/vector-icons';

const SupportComponent = ({showCall, setShowCall}) => {
  return (
    <SlideModal
      visible={showCall}
      onClose={() => setShowCall(false)}
      type="center"
      minWidth={WINDOW_WIDTH / 3}
      customHeaderStyle={styles.modalHeader}
      contentPadding={0}
      modalHeaderTitle={
        <Box flexDirection="row" alignItems="center" justifyContent="center">
          {/* <Box marginRight={8} style={styles.header}>
            <MaterialCommunityIcons
              name="whatsapp"
              size={20}
              color={CCColors.White}
            />
          </Box> */}
          <CCText fontWeight={500} fontSize={FontSizes[20]}>
            Connect with our live agent
          </CCText>
        </Box>
      }>
      <Box
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        style={styles.wrapper}>
        <Image source={callBgPattern} style={styles.bgPattern} />
        <Pressable
          onPress={() =>
            Linking.openURL(SUPPORT_PHONE_NUMBERS.INDIA.whatsapp).catch(err =>
              console.error('Error opening WhatsApp:', err),
            )
          }
          style={styles.container1}>
          <Box flexDirection="row" alignItems="center" gap={12}>
            <Box style={styles.waIconBadge}>
              <MaterialCommunityIcons
                name="whatsapp"
                size={22}
                color={CCColors.White}
              />
            </Box>
            <Box gap={4} style={{flex: 1}}>
              <Box flexDirection="row" alignItems="center" gap={6}>
                <CCText
                  fontWeight="bold"
                  fontSize={FontSizes[16]}
                  color={CCColors.Primary.Dark}
                  style={styles.phoneLink}>
                  {SUPPORT_PHONE_NUMBERS.INDIA.display}
                </CCText>
                <MaterialCommunityIcons
                  name="open-in-new"
                  size={14}
                  color={CCColors.Primary.Dark}
                />
              </Box>
              <CCText
                color={CCColors.TextColor.GreyText || CCColors.TextColor.Grey}
                fontWeight="medium"
                textBreakStrategy="simple"
                fontSize={FontSizes[12]}>
                {SUPPORT_PHONE_NUMBERS.INDIA.hours.anytime}
              </CCText>
              <CCText
                fontSize={FontSizes[11]}
                color="#25D366"
                fontWeight="bold">
                Tap to chat on WhatsApp
              </CCText>
            </Box>
            <MaterialCommunityIcons
              name="chevron-right"
              size={22}
              color={CCColors.TextColor.Grey}
            />
          </Box>
        </Pressable>
        {/* <Box alignItems="center" justifyContent="center" style={styles.footer}>
          <CCText fontWeight={500} fontSize={FontSizes[12]}>
            Standard carrier rates may apply.
          </CCText>
        </Box> */}
      </Box>
    </SlideModal>
  );
};

export default SupportComponent;

const styles = StyleSheet.create({
  header: {
    padding: 10,
    backgroundColor: '#25D366',
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    height: 20,
    width: 20,
  },
  wrapper: {
    borderColor: CCColors.BorderLight,
    borderTopWidth: 1,
    position: 'relative',
  },
  container1: {
    width: '90%',
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 16,
    paddingBottom: 16,
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#25D366',
    backgroundColor: '#F0FDF4',
    cursor: 'pointer',
  },
  waIconBadge: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#25D366',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneLink: {
    textDecorationLine: 'underline',
  },
  footer: {
    backgroundColor: CCColors.CCTableBg,
    padding: 8,
    width: '100%',
  },
  bgPattern: {
    width: 119,
    height: 108,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -10,
  },
  modalHeader: {
    paddingTop: 24,
    paddingBottom: 15,
    paddingHorizontal: 32,
  },
});
